module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    attrs: {
      "leftVisible": false
    }
  }, [(_vm.vtwo) ? _c('div', {
    staticClass: "red lighten-3 pa-4"
  }, [_vm._v("\n    This is an outdated version of Taco. Please update your links to https://taco.insightprocessing.com.au\n")]) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "slot": "header",
      "dark": "",
      "dense": ""
    },
    slot: "header"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Taco")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.tenantKey == '1') ? _c('AlgoliaContacts', {
    ref: "algoliaSearch",
    on: {
      "select": _vm.showActionsForAlgoliaContact,
      "jump": _vm.goToLatestTransaction
    }
  }) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "bottom": "",
      "origin": "top left",
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "xcolor": "blue darken-3",
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-account-plus")])], 1)]
      }
    }]),
    model: {
      value: (_vm.addMenuVisible),
      callback: function($$v) {
        _vm.addMenuVisible = $$v
      },
      expression: "addMenuVisible"
    }
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.addClients
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("supervisor_account")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Add Client")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.editContact(null)
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Add Contact")])], 1)], 1)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "max-height": 510,
      "left": "",
      "bottom": "",
      "origin": "top left",
      "nudge-bottom": 43,
      "nudge-right": 21,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("menu")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/living')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Living Expense Tool")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/charts/select')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Charts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/charts/rotate')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Cycle Charts")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/' + _vm.tenantKey + '/transaction/' + _vm.masterKey)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Open Master Template")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.emailOfficeInvite
    }
  }, [_c('v-list-item-title', [_vm._v("Send Invite")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.isChatting = !_vm.isChatting
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Chat Visible")]), _vm._v(" "), (_vm.isChatting) ? _c('v-icon', [_vm._v("check")]) : _vm._e()], 1), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": _vm.test
    }
  }, [_c('v-list-item-title', [_vm._v("Testing")])], 1) : _vm._e(), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/billing')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Billing")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.reassignTasksDialog.settings.visible = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Reassign All Tasks")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.lookupDataDialog.settings.visible = true
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Lookup Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/mail-log')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Email Logs")])], 1), _vm._v(" "), (_vm.isInsight) ? _c('v-list-item', {
    on: {
      "click": _vm.reindexContacts
    }
  }, [_c('v-list-item-title', [_vm._v("Reindex Contacts")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.tasksByLenderSettings.condensed = !_vm.tasksByLenderSettings.condensed
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Condensed")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/download')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Contacts Download")])], 1)], 1)], 1), _vm._v(" "), (_vm.loadingMessage) ? _c('v-progress-circular', {
    staticClass: "white--text",
    attrs: {
      "indeterminate": ""
    },
    on: {
      "click": _vm.stopLoading
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingMessage) ? _c('v-menu', {
    staticClass: "account-menu",
    attrs: {
      "min-width": "260",
      "left": "",
      "bottom": "",
      "origin": "top left",
      "nudge-top": 0,
      "nudge-right": 0,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('img', {
          staticClass: "round clickable",
          attrs: {
            "width": "35",
            "height": "35",
            "src": _vm.userImage
          }
        })])]
      }
    }], null, false, 855373697)
  }, [_vm._v(" "), _c('div', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "width": "100%",
      "padding-left": "16px",
      "padding-top": "14px",
      "padding-bottom": "4px",
      "font-size": "1.2em"
    }
  }, [_c('img', {
    staticClass: "round clickable",
    staticStyle: {
      "float": "right",
      "margin-top": "-8px",
      "margin-right": "6px"
    },
    attrs: {
      "width": "35",
      "height": "35",
      "src": _vm.userImage
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("fullName")(_vm.user)))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "grey--text",
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/preferences')
      }
    }
  }, [_c('v-list-item-action', [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("Preferences")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.showActivityHistory
    }
  }, [_c('v-list-item-action', [_c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("restore")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v("My Activity History")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "200px",
      "overflow-y": "scroll"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "white",
    staticStyle: {
      "width": "100%",
      "padding": "10px 16px 16px 16px",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    staticClass: "primary mr-1",
    nativeOn: {
      "click": function($event) {
        return _vm.signOut($event)
      }
    }
  }, [_vm._v("Sign Out")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary"
  }, [_vm._v("Close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('table', {
    staticStyle: {
      "margin-top": "3px",
      "margin-bottom": "-2px",
      "margin-left": "17px"
    }
  }, [_c('tr', [_c('td', [_c('v-icon', {
    staticStyle: {
      "margin-top": "3px",
      "margin-right": "7px"
    }
  }, [_vm._v("mdi-account-circle")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "nudge-bottom": 10,
      "max-height": 300,
      "transition": "slide-y-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({
          staticStyle: {
            "display": "flex",
            "margin-top": "5px"
          }
        }, on), [_c('div', {
          staticStyle: {
            "font-size": "16px",
            "color": "#666",
            "white-space": "nowrap",
            "cursor": "pointer"
          }
        }, [_vm._v("\n                            " + _vm._s(_vm.tasksHeading) + "\n                        ")]), _vm._v(" "), _c('div', [_c('v-icon', [_vm._v("mdi-menu-down")])], 1)])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showMyTasks()
      }
    }
  }, [_c('v-list-item-title', [_vm._v("My Tasks")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.officesWithUsers), function(office, officeIndex) {
    return [_c('v-list-item', {
      key: officeIndex,
      attrs: {
        "xclass": "grey lighten-4"
      },
      on: {
        "click": function($event) {
          return _vm.showOfficeTasks(office)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(office.name))])], 1), _vm._v(" "), _c('v-divider', {
      key: 'd1' + officeIndex
    }), _vm._v(" "), _vm._l((office.users), function(userItem, userIndex) {
      return _c('v-list-item', {
        key: officeIndex + '-' + userIndex,
        on: {
          "click": function($event) {
            return _vm.showUserTasks(office, userItem)
          }
        }
      }, [_c('v-list-item-title', {
        staticStyle: {
          "font-weight": "100"
        }
      }, [_vm._v(_vm._s(userItem.firstName) + " " + _vm._s(userItem.lastName))])], 1)
    }), _vm._v(" "), (office.users.length) ? _c('v-divider', {
      key: 'd2' + officeIndex
    }) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('td', [_c('v-icon', {
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_vm._v("mdi-calendar-range")])], 1), _vm._v(" "), _c('td', {
    staticClass: "pt-1"
  }, [_c('LabelMenu', {
    attrs: {
      "menus": [{
        value: 'Today'
      }, {
        value: 'Week'
      }, {
        value: 'All Upcoming'
      }]
    },
    model: {
      value: (_vm.searchDuration),
      callback: function($$v) {
        _vm.searchDuration = $$v
      },
      expression: "searchDuration"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "width": "50"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.goToDashboards
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("insert_chart")])], 1)], 1)])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('Announcements'), _vm._v(" "), _c('TaskWarnings', {
    attrs: {
      "tasks": _vm.filteredLocalTasks
    }
  }), _vm._v(" "), (_vm.searchDuration != 'Week') ? _c('TasksByLender', {
    attrs: {
      "settings": _vm.tasksByLenderSettings,
      "tasks": _vm.filteredLocalTasks
    },
    on: {
      "clicked": _vm.taskClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.searchDuration == 'Week') ? _c('KanbanView', {
    attrs: {
      "stages": _vm.kanbanViewStages,
      "items": _vm.filteredLocalTasks,
      "fieldPath": "due"
    },
    on: {
      "move": _vm.kanbanMoved,
      "click": _vm.taskClicked
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var task = ref.item;

        return [_c('div', {
          staticClass: "hoverable clickable",
          staticStyle: {
            "position": "relative",
            "margin": "2px",
            "border-radius": "3px",
            "padding": "5px",
            "width": "236px",
            "border": "dotted 1px #ccc"
          }
        }, [(task.important) ? _c('div', {
          staticStyle: {
            "position": "absolute",
            "width": "12px",
            "height": "12px",
            "top": "4px",
            "right": "4px",
            "background-color": "rgba(23, 124, 224, 0.6)",
            "border-radius": "5px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(task.clients) + " "), _c('span', {
          staticClass: "light-text"
        }, [_vm._v(_vm._s(task.title))])])]
      }
    }], null, false, 801679173)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center-text"
  }, [(_vm.overdueFilteredTasks.length) ? _c('v-btn', {
    staticClass: "mt-4",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "rounded": "",
      "depressed": "",
      "dark": "",
      "color": "red lighten-2"
    },
    on: {
      "click": _vm.bringForward
    }
  }, [_vm._v("\n                    Reschedule " + _vm._s(_vm.overdueFilteredTasks.length) + " Overdue to Today\n                ")]) : _vm._e(), _vm._v(" "), (_vm.search.length) ? _c('div', {
    staticClass: "ma-4"
  }, [_c('div', {
    staticClass: "light-text"
  }, [_vm._v("Tasks are filtered based on search text")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-1",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v("\n                        Clear Search\n                    ")])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.filteredLocalTasks.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n                No tasks\n            ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {}, [(_vm.debugInfinite) ? _c('div') : _vm._e(), _vm._v(" "), _c('OfficeChooser', {
    staticStyle: {
      "padding": "8px",
      "margin-bottom": "-16px"
    },
    attrs: {
      "buttonStyle": "background-color: rgba(0,0,0,0.4);color:white;"
    }
  })], 1), _vm._v(" "), _c('ContactSearch', {
    ref: "contactSearch",
    staticClass: "no-padding ma-2",
    attrs: {
      "global": true
    },
    on: {
      "click": _vm.contactClicked,
      "add": function($event) {
        _vm.addMenuVisible = true
      },
      "search": _vm.contactSearchChanged,
      "jump": _vm.goToLatestTransaction
    }
  })], 1), _vm._v(" "), [(_vm.renameTransactionDialog.visible) ? _c('v-dialog', {
    attrs: {
      "min-width": "300",
      "max-width": "300",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.renameTransactionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.renameTransactionDialog, "visible", $$v)
      },
      expression: "renameTransactionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container rounded pa-3"
  }, [_c('v-text-field', {
    ref: "oldTransactionName",
    attrs: {
      "label": "Rename to",
      "placeholder": "Transaction Name",
      "value": _vm.renameTransactionDialog.transaction.description,
      "hint": "Enter to continue..."
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveRename($event)
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.actionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.actionDialog, "visible", $$v)
      },
      expression: "actionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm._f("fullName")(_vm.actionDialog.model)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "nudge-width": 200
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "dark": ""
          }
        }, on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [(_vm.isInsight) ? [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openFirebase(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewContactTransactionData(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Contact Transaction Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewUserData(_vm.actionDialog.model.meta.key)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View User Data")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showContactMaintenance(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Contact Maintenance")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.showCharge(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Charge Invoice")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.editPreferences(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Edit Preferences")])], 1)] : _vm._e(), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.viewEmailLogs(_vm.actionDialog.model.email)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("View Mail Logs")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.removeUserStatus(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Remove User Status")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "blue lighten-4",
    staticStyle: {
      "padding": "7px 20px 7px 20px"
    }
  }, [(_vm.actionDialog.model.partner) ? [_vm._v("\n                    Partner: "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.switchToPartner(_vm.actionDialog.model.partner.key)
      }
    }
  }, [_vm._v(_vm._s(_vm.actionDialog.model.partner.firstName + ' ' + _vm.actionDialog.model.partner.lastName))]), _vm._v(" | \n                    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.removeSpouse(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Separate")])] : [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectSpouse(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Add Partner")])]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('CommunicationBar', {
    attrs: {
      "contact": _vm.actionDialog.model
    }
  }), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "ripple": false,
      "two-line": ""
    }
  }, [_c('v-subheader', {
    staticStyle: {
      "margin-bottom": "-15px"
    }
  }, [_vm._v("Transactions")]), _vm._v(" "), _vm._l((_vm.actionDialog.transactions), function(transaction, transactionIndex) {
    return [_c('v-list-item', {
      key: transaction.key || transaction['.key'],
      attrs: {
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.openTransaction(transaction)
        }
      }
    }, [_c('v-list-item-avatar', [_c('img', {
      attrs: {
        "src": _vm.imagePath(transaction)
      }
    })]), _vm._v(" "), _c('v-list-item-content', {
      attrs: {
        "ripple": false
      }
    }, [_c('v-list-item-title', {
      attrs: {
        "ripple": false
      }
    }, [_vm._v("\n                                " + _vm._s(transaction.name) + _vm._s(transaction.description) + "  \n                            ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm._f("longDate")(transaction.created)))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": ""
            }
          }, on), [_c('v-icon', {
            attrs: {
              "color": "grey"
            }
          }, [_vm._v("keyboard_arrow_down")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Open Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openChecklist(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Open Checklist")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.renameTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Rename Transaction")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteTransaction(transaction)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Transaction")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('v-divider', {
      key: 'd1-' + transactionIndex
    })]
  }), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addTransactionForContact(_vm.actionDialog.model)
      }
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    staticClass: "text--lighten-1 grey--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Add Transaction\n                    ")]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("New transaction for " + _vm._s(_vm.actionDialog.model.firstName))])], 1)], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editContact(_vm.actionDialog.model)
      }
    }
  }, [_vm._v("Edit Contact")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actionDialogClose($event)
      }
    }
  }, [_vm._v("Close")])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "min-width": "500",
      "max-width": "500",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "transition": "v-fade-transition",
      "hide-overlay": true,
      "scrollable": ""
    },
    model: {
      value: (_vm.transactionDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog, "visible", $$v)
      },
      expression: "transactionDialog.visible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("New File for " + _vm._s(_vm.transactionDialog.contact.firstName))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-text-field', {
    ref: "transactionName",
    attrs: {
      "label": "Transaction Name",
      "hint": "eg. Refinance home with cashout to purchase car"
    },
    model: {
      value: (_vm.transactionDialog.model.description),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog.model, "description", $$v)
      },
      expression: "transactionDialog.model.description"
    }
  }), _vm._v(" "), (_vm.transactionDialog.contact.partner) ? [_c('v-checkbox', {
    attrs: {
      "label": ("Joint with " + (_vm.transactionDialog.contact.partner.firstName)),
      "color": "primary"
    },
    model: {
      value: (_vm.transactionDialog.withPartner),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog, "withPartner", $$v)
      },
      expression: "transactionDialog.withPartner"
    }
  })] : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.transactionTemplates,
      "label": "Template",
      "item-value": "meta.key",
      "item-text": "description"
    },
    model: {
      value: (_vm.transactionDialog.model.masterKey),
      callback: function($$v) {
        _vm.$set(_vm.transactionDialog.model, "masterKey", $$v)
      },
      expression: "transactionDialog.model.masterKey"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.transactionDialog.model.description.length < 1
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transactionDialogSave($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.transactionDialogCancel($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)])]), _vm._v(" "), _c('ContactSelector', {
    attrs: {
      "visible": _vm.contactSelector.visible,
      "title": _vm.contactSelector.title,
      "data": _vm.contactSelector.data
    },
    on: {
      "select": _vm.linkSpouse,
      "cancel": function($event) {
        _vm.contactSelector.visible = false
      }
    }
  }), _vm._v(" "), _c('ContactEditor', {
    attrs: {
      "settings": _vm.contactEditor.settings,
      "contactItem": _vm.contactEditor.contact
    }
  }), _vm._v(" "), _c('AddClients', {
    attrs: {
      "visible": _vm.addClientsVisible,
      "title": "Add Clients"
    },
    on: {
      "save": _vm.savedClients,
      "cancel": function($event) {
        _vm.addClientsVisible = false
      }
    }
  }), _vm._v(" "), _c('GenericListDialog', {
    attrs: {
      "items": _vm.genericListDialog.items,
      "settings": _vm.genericListDialog.settings,
      "clickHandler": _vm.logItemClicked
    }
  }), _vm._v(" "), _c('MaintenanceDialog', {
    attrs: {
      "initialProgram": "tc",
      "item": _vm.maintenanceDialog.item,
      "settings": _vm.maintenanceDialog.settings
    }
  }), _vm._v(" "), _c('EmailDialog', {
    attrs: {
      "settings": _vm.emailDialog.settings,
      "email": _vm.emailDialog.email,
      "returnObject": _vm.emailDialog.returnObject
    }
  }), _vm._v(" "), (_vm.chargeDialog.settings.visible) ? _c('ChargeDialog', {
    attrs: {
      "settings": _vm.chargeDialog.settings,
      "charge": _vm.chargeDialog.charge
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reassignTasksDialog.settings.visible) ? _c('ReassignTasksDialog', {
    attrs: {
      "settings": _vm.reassignTasksDialog.settings
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lookupDataDialog.settings.visible) ? _c('LookupDataDialog', {
    attrs: {
      "settings": _vm.lookupDataDialog.settings
    }
  }) : _vm._e(), _vm._v(" "), _c('KeyPress', {
    attrs: {
      "key-code": 191,
      "event": "keyup"
    },
    on: {
      "pressed": _vm.setSearchFocus
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d793428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 2446
// module chunks = 1